export function createAfterFormLoadEvent() {
    return new CustomEvent("d365mkt-afterformload", { bubbles: true });
}
